import { IApiAdjustmentProfile, IApiAdjustmentProfilesDefault } from '@cbridge-packages/api';
import { IAdjustment, IAdjustmentDefault } from './adjustmentProfile.interface';

export namespace AdjustmentProfileTranslator {
  export function fromApi(adjustment: IApiAdjustmentProfile): IAdjustment {
    return {
      adjustmentId: adjustment.id,
      name: adjustment.name,
      priceMultiplier: adjustment.priceMultiplier,
      volumeMultiplier: adjustment.volumeMultiplier,
    };
  }

  export function toApi(adjustment: IAdjustment): IApiAdjustmentProfile {
    return {
      id: adjustment.adjustmentId,
      name: adjustment.name,
      priceMultiplier: adjustment.priceMultiplier,
      volumeMultiplier: adjustment.volumeMultiplier,
    };
  }

  export function defaultFromApi(adjustment: IApiAdjustmentProfilesDefault): IAdjustmentDefault {
    return {
      priceMultiplier: adjustment.priceMultiplier,
      volumeMultiplier: adjustment.volumeMultiplier,
    };
  }
}
